import styled from "styled-components";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";

const Wrap = styled.div`
	margin-top: 60px;
`;

const Content = styled.div`
	position: relative;
	scroll-margin: 60px;
`;

const TopNavi = styled.ul`
	position: sticky;
	top: 0;
	display: flex;
	width: 100%;
	margin-left: 1px;
	z-index: 15;

	li {
		width: 33.3333%;
		height: 60px;
		font-size: var(--medium-size);
		cursor: pointer;
		vertical-align: middle;
		text-align: center;
		flex: 1 1 0;

		&:not(:last-child) a {
			border-right: none;
		}
	}
`;

const TopNaviItem = styled.a<{isActive: boolean}>`
	display: flex;
	height: 100%;
	width: 100%;
	border: 1px solid var(--line-color);
	border-bottom-color: var(--emp-color);
	background-color: var(--disabled-color);
	align-items: center;
	flex-direction: column;
	justify-content: center;
	box-sizing: border-box;
	line-height: 1;
	gap: 5px;
	color: var(--gray-color);

	${props =>
		props.isActive &&
		`
            border: 1px solid var(--emp-color);
            border-right: 1px solid var(--emp-color) !important;
            border-bottom-color: #fff;
            background-color: #fff;
			color: var(--emp-color);
        `}
	em {
		font-size: var(--medium-size);
	}
`;

const ScrollTabList = styled.ul`
	position: sticky;
	top: 60px;
	display: flex;
	width: 100%;
	padding-top: 30px;
	margin-left: 1px;
	background-color: #fff;
	z-index: 10;

	li {
		display: flex;
		height: 50px;
		align-items: center;
		justify-content: center;
		flex: 1 1 0;

		&:not(:last-child) a {
			border-right: none;
		}
	}
`;

const ScrollTabItem = styled.a<{isActive: boolean}>`
	display: flex;
	width: 100%;
	height: 100%;
	background-color: #fff;
	color: var(--emp-color);
	cursor: pointer;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--line-color);
	box-sizing: border-box;

	${props =>
		props.isActive &&
		`
		border: none;
		background-color: var(--emp-color);
		color: #fff;
	`}
`;

const ScrollContent = styled.div`
	scroll-margin: 150px;
`;

const DayList = styled.div`
	position: sticky;
	top: 140px;
	width: 100%;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;

	ul {
		display: flex;
		height: 60px;
		overflow-x: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		&::-webkit-scrollbar {
			display: none;
		}

		li:first-child {
			a {
				margin-left: 0;
			}
		}

		li:last-child {
			a {
				margin-right: 0;
			}
		}
	}
`;

const DayListItem = styled.a<{isActive: boolean}>`
	position: relative;
	display: flex;
	height: 100%;
	margin: 0 15px;
	color: var(--gray-color);
	white-space: nowrap;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	letter-spacing: -0.6px;

	${props =>
		props.isActive &&
		`	
			color: var(--emp-color);
			 &:before {
				 position: absolute;
				 bottom: 0;
				 left:0;
				 width: 100%;
				 height: 2px;
				 background-color:var(--yellow-color);
				 content: "";
			 }
		 `}
`;

const ScheduleContent = styled.div`
	height: 50vh;
	scroll-margin: 200px;
`;

const PlayBox = styled.div`
	position: relative;
	height: 0;
	max-width: 910px;
	padding-top: 512px;
	margin: 40px auto 0;

	> div {
		position: absolute;
		top: 0;
	}
`;

const ImgEditor = styled.div`
	margin-top: 40px;
	text-align: center;

	img {
		height: auto;
		max-width: 100%;
		vertical-align: top;
	}
`;

const SurchargeBox = styled.div`
	margin: 20px 0;

	img {
		display: block;
		width: 100%;
		margin: 0 auto;
		vertical-align: top;
	}
`;

const SubTitleWrap = styled.div`
	margin: 60px 0 20px;
`;

const EditorWrap = styled.div<{elementHeight: string}>`
	position: relative;
	overflow: hidden;
	max-height: ${props => props.elementHeight};
`;

const TabContent = styled.div``;

const ContentTitle = styled(SubTitle)`
	margin: 60px 0 20px;
`;

export {
	Wrap,
	Content,
	TopNavi,
	TopNaviItem,
	ScrollTabList,
	ScrollTabItem,
	ScrollContent,
	DayList,
	DayListItem,
	ScheduleContent,
	PlayBox,
	ImgEditor,
	SubTitleWrap,
	EditorWrap,
	SurchargeBox,
	TabContent,
	ContentTitle,
};
